export default () => (
  `https://indemandly.s3-ap-southeast-1.amazonaws.com/images/business/${Math.ceil(Math.random() * 8)}.jpg`
)
